<template>
	<div style="padding: 15px;">
		<h1>Refund Policy</h1>
		<div class="terms">
			<div>
				<div style="padding-left: 20px;">
					<div>* Refund requests are accepted only within 24 hours of payment.</div>
					<div>* No refund will be provided after 24 hours from the transaction time.</div>
					<div>* If the uploaded X-ray image quality is poor, unclear, incomplete, or substandard, the deducted amount is non-refundable.</div>
					<div>* Uploading the wrong X-ray image or incorrect patient image will not be eligible for a refund.</div>
					<div>* Selecting the wrong test/report type by the user is non-refundable.</div>
					<div>* Once the reporting process has started, cancellation and refund requests will not be accepted.</div>
					<div>* Refunds, if approved, will be processed to the original payment method within the applicable processing time.</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'RefundPolicy',
	data() {
		return {
			// Add your data properties here
		};
	},
	computed: {
		// Add your computed properties here
	},
	methods: {
		// Add your methods here
	},
	mounted() {
		// Add your mounted lifecycle hook here
	}
};
</script>

<style scoped>
.terms div{
	margin-top: 20px;
}
</style>